import { Modal, ModalBody, ModalContent, ModalHeader } from '@heroui/react';
import { scaleInOut } from '@/shared/lib/utils/modalTransitions';
import { SectionLoader } from '@/shared/ui/Loader';
import { useModalAutoFocus } from '@/shared/lib/hooks';

type TurnitinViewerModalProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  viewerUrl: string | null;
  isLoading: boolean;
};

export const TurnitinViewerModal = ({
  isOpen,
  onOpenChange,
  viewerUrl,
  isLoading,
}: TurnitinViewerModalProps) => {
  useModalAutoFocus(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      motionProps={scaleInOut}
      classNames={{
        base: 'min-w-full h-full max-h-[100vh] min-h-[100vh] rounded-none !m-0 sm:!mx-0 sm:!my-0',
        wrapper: 'rounded-none',
      }}
    >
      <ModalContent className="rounded-none">
        <ModalHeader className="text-xl font-semibold">Turnitin Similarity Report</ModalHeader>
        <ModalBody className="p-0">
          {isLoading ? (
            <div className="flex items-center justify-center h-[calc(100vh-64px)]">
              <SectionLoader />
            </div>
          ) : viewerUrl ? (
            <div className="relative h-[calc(100vh-64px)] w-full">
              <iframe
                title="Turnitin Viewer"
                className="h-full w-full border-0"
                src={viewerUrl}
                allowFullScreen
              />
            </div>
          ) : (
            <div className="flex items-center justify-center h-[calc(100vh-64px)]">
              <p className="text-red-600">Failed to load viewer URL</p>
            </div>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
